export type AutoBattleMode = "rotation" | "assist" | "tactician" | "strategist";

export interface AutoBattleModeInfo {
  id: AutoBattleMode;
  name: string;
  description: string;
  badge?: "VIP" | "Pro";
}

export const AUTO_BATTLE_MODES: AutoBattleModeInfo[] = [
  {
    id: "rotation",
    name: "Skill rotation",
    description: "Use skills in the order set on the Hero screen.",
  },
  {
    id: "assist",
    name: "Assist",
    description: "Basic AI: heal and lifesteal when needed; no AoE vs a single enemy.",
  },
  {
    id: "tactician",
    name: "Smart",
    description: "Smarter: saves ultimates on nearly dead targets and spends mana wisely.",
    badge: "VIP",
  },
  {
    id: "strategist",
    name: "Elite AI",
    description: "Optimal play: picks the best skill to win, including aggressive ults when needed.",
    badge: "Pro",
  },
];

export function autoBattleLabel(mode: AutoBattleMode): string {
  return AUTO_BATTLE_MODES.find((m) => m.id === mode)?.name ?? mode;
}

export function isCampaignFightNode(displayType: string): boolean {
  return ["battle", "elite", "final_boss", "boss", "mystery"].includes(displayType);
}
